<template>
  <div class="footer">
    <div class="footer-bottom">
      <div>
        <router-link :to="'/cookies'">
          {{ $t("common.cookies") }}
        </router-link>
        |
        <router-link :to="'/privacy'">
          {{ $t("common.privacy") }}
        </router-link>
        |
        <router-link :to="'/terms'">
          {{ $t("common.termsAndConditions") }}
        </router-link>
      </div>
      <div align="center">
        <a href="https://www.aiwannapay.com/">
          <img
            width="150"
            height="36"
            src="@/assets/images/aiwannapaylogo.png"
            alt="aiwanna pay"
          />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer"
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
